import { IocContext } from 'power-di';

export * from 'power-di';

export const globalContext = IocContext.DefaultInstance;
